import Overview from '@rebuild/materials/shared/quote/SlideOverview.vue';
import MobFull from '@/rebuild/materials/shared/quote/mobile/SlideMobFull.vue';

export const componentMap = {
    overview: Overview,
    'mob-full': MobFull
}; 